import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	freeTrialBanner: {
		id: 'freeTrialPlans.planPicker.freeTrial.banner',
		defaultMessage: 'Limited Time Offer',
		description: 'Free trial banner',
	},
	freeTrialPlanName: {
		id: 'freeTrialPlans.planPicker.freeTrial.title',
		defaultMessage: '7-Day Free Trial',
		description: 'Free trial plan title',
	},
	couponPlanName: {
		id: 'freeTrialPlans.planPicker.subscribe.couponTitle',
		defaultMessage: '{percent}% off 1 Year',
		description: 'Plan title for coupon flow',
	},
	genericYearlyPlanName: {
		id: 'freeTrialPlans.planPicker.subscribe.title',
		defaultMessage: 'Yearly subscription',
		description: 'Geenric plan title for yearly sub',
	},
	freeTrialDetails: {
		id: 'freeTrialPlans.planPicker.freeTrial.subtitle',
		defaultMessage: 'then {formattedPrice} billed annually, cancel anytime',
		description: 'Free trial plan details',
	},
	subscribeDetails: {
		id: 'freeTrialPlans.planPicker.subscribe.subtitle',
		defaultMessage: '{currentPrice} for 1 year, then {nextPrice} billed annually',
		description: 'Subscribe plan details',
	},
	freeTrialButton: {
		id: 'freeTrialPlans.planPicker.freeTrial.buttonText',
		defaultMessage: 'Get Started',
		description: 'Free trial cta',
	},
	foreverBanner: {
		id: 'freeTrialPlans.planPicker.forever.banner',
		defaultMessage: 'Get everything, forever',
		description: 'Forever plan banner',
	},
	foreverPlanName: {
		id: 'freeTrialPlans.planPicker.forever.title',
		defaultMessage: 'Calm for Life',
		description: 'Forever plan title',
	},
	foreverDetails: {
		id: 'freeTrialPlans.planPicker.forever.subtitle',
		defaultMessage: '{formattedPrice} billed once, get it forever',
		description: 'Forever plan details',
	},
	foreverButton: {
		id: 'freeTrialPlans.planPicker.forever.buttonText',
		defaultMessage: 'Buy Now',
		description: 'Forever plan cta',
	},
});
